module.exports = __webpack_public_path__ + "img/dog-face.868bda6b.png";